import { useCallback } from 'react';

import { useMemberId } from '@trello/authentication';
import { useBoardId } from '@trello/id-context';
import { useSharedStateSelector } from '@trello/shared-state';

import { cachedInboxIdsState } from './cachedInboxIdsState';
import type { InboxIds } from './Inbox.types';

export const useMemberInboxIds = (): Partial<InboxIds> => {
  const memberId = useMemberId();
  const inboxIds = useSharedStateSelector(
    cachedInboxIdsState,
    useCallback((state) => state[memberId], [memberId]),
  );

  return inboxIds || {};
};

export const useIsInboxBoardPassContextVals = ({
  boardId,
  memberId,
}: {
  boardId: string | null;
  memberId: string;
}) => {
  const isInboxBoard = useSharedStateSelector(
    cachedInboxIdsState,
    useCallback(
      (state) => {
        const inboxIds = state[memberId];
        return Boolean(inboxIds?.idBoard && inboxIds.idBoard === boardId);
      },
      [boardId, memberId],
    ),
  );

  return isInboxBoard;
};

export const useIsInboxBoard = () => {
  const boardId = useBoardId();
  const memberId = useMemberId();

  return useIsInboxBoardPassContextVals({ boardId, memberId });
};
